import cc from './src/cc'
export default cc


// WEBPACK FOOTER //
// ./src/components/YcyPlayer/index.js